import { Tag } from 'antd';
import React from 'react';
import { evidenceStatusLabel } from './viewModel';

export const CONTROL_STATUS = {
  automated_failure: { color: 'error' },
  manual_review_required: { color: 'processing' },
  manual_pass: { color: 'success' },
  manual_fail: { color: 'error' },
  not_applicable: { color: 'default' },
  blocked: { color: 'warning' },
  not_started: { color: 'default' },
};

export const AUTOMATION_POTENTIAL = {
  failure_evidence: { label: 'Automated detection' },
  review_signal: { label: 'Automated signal' },
  manual_only: { label: 'Manual check only' },
};

export const REVIEW_UNIT_STATUS = {
  not_started: { color: 'default', label: 'Not started' },
  in_progress: { color: 'processing', label: 'In progress' },
  completed: { color: 'success', label: 'Completed' },
  blocked: { color: 'warning', label: 'Blocked' },
};

export const controlStatus = (status, props = {}) => {
  const value = CONTROL_STATUS[status] || { color: 'default' };
  return <Tag {...props} color={value.color}>{evidenceStatusLabel(status)}</Tag>;
};

export const syncStatus = value => {
  const status = typeof value === 'string' ? value : value?.status;
  const normalizedStatus = typeof status === 'string' ? status.toLowerCase() : 'unknown';
  return (
    <Tag color={normalizedStatus === 'completed' ? 'success' : normalizedStatus === 'running' || normalizedStatus === 'pending' ? 'processing' : normalizedStatus === 'incomplete' ? 'warning' : 'error'}>
      {normalizedStatus}
    </Tag>
  );
};

export const automationPotential = (potential, props = {}) => {
  const value = AUTOMATION_POTENTIAL[potential] || { label: 'Manual check only' };
  return <Tag {...props}>{value.label}</Tag>;
};

export const reviewUnitStatus = status => {
  const value = REVIEW_UNIT_STATUS[status] || REVIEW_UNIT_STATUS.not_started;
  return <Tag color={value.color}>{value.label}</Tag>;
};
